import React from "react";
import { FaFacebookF, FaInstagram, FaPhone } from "react-icons/fa";
import "../styles/Footer.css";
import LogoSVG from "./LogoSVG";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <LogoSVG height={54} className="footer-logo" />
        </div>
        <div className="footer-links">
          <a href="tel:+386040942579" className="footer-link">
            <FaPhone style={{ marginRight: "6px" }} />
            040 942 579
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=100063458109926"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link footer-social"
            aria-label="Facebook"
          >
            <FaFacebookF />
          </a>
          <a
            href="https://www.instagram.com/astrologyinvortex/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link footer-social"
            aria-label="Instagram"
          >
            <FaInstagram />
          </a>
        </div>
      </div>
      <div className="footer-bottom">
        © {new Date().getFullYear()} Astrologija v Vortexu — Vse pravice
        pridržane
      </div>
    </footer>
  );
};

export default Footer;
